<template>
  <div class="order-table">
    <el-table ref="orderMultipleTable" :data="orderTableData" style="width: 100%" max-height="300"
      @selection-change="selectOrder" border show-summary :summary-method="getSummaries" v-if="table"
      :loading="loading">
      <el-table-column type="selection" width="55" fixed="left">
      </el-table-column>
      <el-table-column type="index" label="序号" width="50" fixed="left">
      </el-table-column>
      <el-table-column prop="created_at" label="推送日期" width="120">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.created_at }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="out_ware_day" label="要求发货日">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.out_ware_day }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="user_name" label="客户姓名" v-if="isFactory">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            <MaskViewVue type="maskName" :maskVal="scope.row.user_name" :customParams="{
              expand: JSON.stringify({
                xAPIVersion: 'V1.0',
                xSystemID: 'diablo',
              }),
            }" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="客户电话" v-if="isFactory">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            <MaskViewVue type="maskPhone" :maskVal="scope.row.mobile" :customParams="{
              expand: JSON.stringify({
                xAPIVersion: 'V1.0',
                xSystemID: 'diablo',
              }),
            }" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="客户地址" v-if="isFactory">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            <MaskViewVue type="maskAddress" :maskVal="scope.row.address" :customParams="{
              expand: JSON.stringify({
                xAPIVersion: 'V1.0',
                xSystemID: 'diablo',
              }),
            }" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="main_number" label="主订单号" width="120">
        <template slot-scope="scope">
          <div class="detailTable" @click="getDetailTable(scope.row)">
            {{ scope.row.main_number }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="shipping_delay_status_str" label="报备状态" width="80" v-if="statusActive !== 5">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.shipping_delay_status_str }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="shipping_delay_status" label="报备类型" width="80" v-if="statusActive !== 5">
        <template slot-scope="scope">
          <!-- 暂时只有这一种，固定文案:"延迟发货" -->
          <div @click="getDetailTable(scope.row)" v-if="
            scope.row.shipping_delay_status == -1 ||
            scope.row.shipping_delay_status == 2
          ">
            延迟发货
          </div>
        </template>
      </el-table-column>

      <!-- 拒单 -->
      <el-table-column prop="order_number" label="子订单号" width="140" v-if="statusActive === 5">
        <template slot-scope="scope">
          <div class="detailTable" @click="getDetailTable(scope.row)">
            {{ scope.row.order_number }}
          </div>
        </template>
      </el-table-column>
      <!--  -->
      <el-table-column prop="serial_number" label="编号" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.serial_number">{{
            scope.row.serial_number
              .split("-")
              .slice(3)
              .join("-")
          }}</span>
          <span v-if="scope.row.express && isZhifaOrFactory">({{ scope.row.express }})</span>
        </template>
      </el-table-column>
      <el-table-column prop="total_price" label="订单总金额">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.total_price }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="total_amount" label="订购总量">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.total_amount }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="total_send_amount" label="实发总量">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.total_send_amount }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="total_send_price" label="实发总金额">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.total_send_price }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="box_num" label="打包箱数" v-if="!isFactory">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            <span class="detailTable" @click="getBoxData(scope.row)">
              {{ scope.row.box_num }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="weight" label="总称重(kg)" v-if="!isFactory">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">{{ scope.row.weight }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="od_statusName" label="状态">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.od_statusName }}
          </div>
        </template>
      </el-table-column>

      <!-- 物流轨迹 - 物流状态 2022-10-14 -->
      <el-table-column prop="box_status_msg" label="物流状态" v-if="statusActive === 4 && isZhifaOrFactory2">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.box_status_msg }}
          </div>
        </template>
      </el-table-column>

      <!-- 2021 03 12 同步状态 -->
      <el-table-column prop="async_create_statusName" label="同步状态" v-if="syncStatusFlag">
        <template slot-scope="scope">
          <el-button type="text" @click="getDetailAsyncStatus(scope.row)">{{
            scope.row.async_create_statusName
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="user_name" label="客户" v-if="!isFactory">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.user_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="courier_number" label="快递单号" v-if="
        statusActive === 1 ||
        statusActive === 2 ||
        statusActive === 3 ||
        statusActive === 4
      ">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)" v-if="scope.row.courier_number">
            {{ scope.row.courier_number }}
          </div>
          <div @click="getDetailTable(scope.row)" v-else>
            {{ scope.row.courier_number_status | courierNumberStatus }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="isZhifaOrFactory && (statusActive === 3 || statusActive === 4)" prop="express"
        label="物流承运商">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">{{ scope.row.express }}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="
        isZhifaOrFactory &&
        (statusActive === 3 || statusActive === 4) &&
        !(statusActive === 4 && isZhifaOrFactory2)
      " prop="courier_mobile" label="物流联系电话">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.courier_mobile }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="serial_number" label="查看子单号" v-if="
        isZhifaOrFactory &&
        (statusActive === 3 || statusActive === 4) &&
        !(statusActive === 4 && isZhifaOrFactory2)
      ">
        <template slot-scope="scope">
          <el-button type="text" class="rejectOrder" @click="getTransportDetail(scope.row)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="ts_status" label="物流状态" width="110" v-if="isZhifa && statusActive === 4 && canInputTs">
        <template slot-scope="scope">
          {{ scope.row.ts_status | tsStatus }}
        </template>
      </el-table-column>
      <!-- 直发出库页签 工厂已备货和已出库页签显示 -->
      <el-table-column prop="courier_type" label="物流通知方式" v-if="
        isZhifaOrFactory &&
        statusActive === 4 &&
        canInputTs &&
        !(statusActive === 4 && isZhifaOrFactory2)
      ">
        <template slot-scope="scope">
          <span v-if="scope.row.courier_type == 1">系统通知</span>
          <span v-if="scope.row.courier_type == 2">非系统通知</span>
        </template>
      </el-table-column>
      <el-table-column prop="courier_odd_status" label="物流单号更新状态" width="120"
        v-if="isZhifa && statusActive === 4 && canInputTs">
        <template slot-scope="scope">
          {{ scope.row.courier_odd_status | courierOddStatus }}
        </template>
      </el-table-column>
      <el-table-column prop="print_num" label="已打印次数" v-if="!isFactory">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.print_num }}
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" :width="isZhifaOrFactory && (statusActive === 3 || statusActive === 4)
        ? 120
        : 90
        " label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" class="rejectOrder" @click="getOrderDetail(scope.row)">查看</el-button>
          <el-button v-if="statusActive === 3 && !isFactory" type="text" class="rejectOrder"
            @click="editOrderHandler(scope.row.id)">编辑</el-button>
          <el-button v-if="statusActive === 1" type="text" class="rejectOrder" @click="refuseOrder(scope.row.id)"
            :disabled="true">拒单</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {
  acceptOrder,
  pareDone,
  bigorderCancelPare,
  refuseOrder,
  jgjRefuseOrder,
  batchPrintBoxCode
} from "@/models/orderModel";
import { print } from "@/models/commonModel";

import { MaskViewVue } from "ruigu-utils";
export default {
  props: ["orderTableData", "statusActive"],
  components: {
    MaskViewVue
  },
  data() {
    return {
      isZhifaOrFactory: true,
      isZhifaOrFactory2:
        localStorage.getItem("shop_type") === "1" ||
        localStorage.getItem("shop_type") === "2",
      isZhifa: false,
      table: true,
      loading: false,
      canInputTs: false,
      isFactory: false,
      syncStatusFlag: null,
      isJgj: localStorage.getItem("is_jgj") === "1" // 为紧固件为true
    };
  },
  filters: {
    courierNumberStatus(val) {
      let text = "";
      switch (val) {
        case "0":
          text = "";
          break;
        case "1":
          text = "通知中";
          break;
        case "2":
          text = "已通知";
          break;
        case "3":
          text = "已通知";
          break;
        case "-1":
          text = "通知失败";
          break;
        default:
          break;
      }
      return text;
    },
    courierOddStatus(val) {
      val += "";
      let text = "";
      switch (val) {
        case "0":
          text = "";
          break;
        case "1":
          text = "更新中";
          break;
        case "2":
          text = "更新成功";
          break;
        case "-1":
          text = "更新失败";
          break;
        case "-2":
          text = "更新失败(可重试)";
          break;
        default:
          break;
      }
      return text;
    },
    tsStatus(val) {
      val += "";
      let text = "";
      switch (val) {
        case "0":
          text = "";
          break;
        case "1":
          text = "新建";
          break;
        case "2":
          text = "准备揽件";
          break;
        case "3":
          text = "已取货";
          break;
        case "4":
          text = "配送中";
          break;
        case "5":
          text = "配送完成";
          break;
        case "6":
          text = "非系统通知订单";
          break;
        case "-1":
          text = "取消";
          break;
        default:
          break;
      }
      return text;
    },
    formatAmount(val) {
      return (+val || "0.00")
        .toString()
        .replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
    },

    filterLogStatus(value) {
      const type = {
        1: "准备揽件",
        2: "已揽件",
        3: "运输中",
        4: "已签收",
        5: "拒收带回"
      };
      return type[value];
    }
  },
  watch: {
    statusActive(val) {
      // 解决错位问题
      this.table = false;
      this.loading = true;
      setTimeout(() => {
        this.table = true;
        this.loading = false;
      }, 100);
      // this.orderForm.orderTableData = val
    }
  },
  methods: {
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    async refuseOrder(id) {
      let params = {
        id: id
      };
      let data;
      if (this.isJgj) {
        // 为紧固件走jgjRefuseOrder接口
        data = await jgjRefuseOrder(params);
      } else {
        data = await refuseOrder(params);
      }
      if (data.message === "Success") {
        this.$message.success("拒单成功");
        this.$emit("updateOrder");
      }
    },
    getDetailTable(data) {
      this.$emit("getDetailTable", data);

      this.$refs.orderMultipleTable.clearSelection();
      this.$refs.orderMultipleTable.toggleRowSelection(data);
      if (this.statusActive == 4 && this.isZhifaOrFactory2) {
        this.$emit("getTrackNo", data);
      }
    },
    getOrderDetail(row) {
      if (row.order_number) {
        this.$router.push({
          name: "bigorderDetail",
          params: { id: row.mo_id, wrongDetail: true }
        });
        // this.$router.push({path: '/order/edit', query: {id: row.mo_id, orderNo: row.order_number}})
      } else {
        this.$router.push({
          path: "/bigorder/edit",
          query: { id: row.id, orderNo: row.order_number }
        });
      }
    },
    selectOrder(val) {
      this.$emit("getSelectOrderData", val);
      if (this.statusActive === 5) {
        if (val.length > 1) {
          this.$message.warning("只能勾选一个");
          this.$refs.orderMultipleTable.clearSelection();
          this.$refs.orderMultipleTable.toggleRowSelection(val[0]);
        }
      }
    },
    async print(data) {
      let ids = [];
      let failedData = [];
      data.forEach(item => {
        ids.push(item.id);
      });
      let params = {
        ids: JSON.stringify(ids)
      };
      let res = await batchPrintBoxCode(params);
      if (res.code === 200) {
        let success = res.data.succeed;
        failedData = res.data.failed;
        if (failedData.length > 0) {
          failedData.forEach(item => {
            item.main_number = data.find(order => {
              return order.id === item.id;
            }).main_number;
          });
          let html = "";
          failedData.forEach(item => {
            html +=
              '<p style="padding:5px;">主订单号：' +
              item.main_number +
              "," +
              item.msg +
              "</p>";
          });
          this.$message({
            showClose: true,
            type: "error",
            iconClass: "11",
            dangerouslyUseHTMLString: true,
            message: html,
            duration: 0
          });
        } else {
          for (const key in success) {
            if (success.hasOwnProperty(key)) {
              let item = success[key];
              for (let i of item) {
                if (!this.isZhifaOrFactory) {
                  delete i["courier_number"];
                }
                i.code = i.serial_number;
                i.print_interval = 5;
                let printData = await print(i);
                // console.log(printData, 'printData')
                if (printData === false) {
                  return false;
                }
              }
            }
          }
        }
      }
      // let data = await getPrintData(params)
      // for (let i of data) {
      //   if (!this.isZhifaOrFactory) {
      //     delete i['courier_number']
      //   }
      //   i.code = i.serial_number
      //   let printData = await print(i)
      //   if (printData === false) {
      //     return false
      //   }
      // }
    },
    async acceptGoods(id) {
      let params = {
        ids: id
      };
      await acceptOrder(params);
      this.$emit("updateOrder"); // 刷新列表
      // this.$emit('acceptGoodsOk')  // 不跳转
    },
    async completeGoods(id) {
      let params = {
        id: id
      };
      await pareDone(params);
      this.$emit("updateOrder");
    },
    async cancelGoods(id) {
      let params = {
        id: id
      };
      await bigorderCancelPare(params);
      this.$emit("updateOrder");
      try {
        let scanningData = JSON.parse(
          localStorage.getItem("bigorderscanningData")
        );
        scanningData = scanningData.filter(item => item.id !== id);
        localStorage.setItem(
          "bigorderscanningData",
          JSON.stringify(scanningData)
        );
      } catch (error) { }
    },
    // async outGoods (id) {
    //   let params = {
    //     ids: id
    //   }
    //   await outWare(params)
    //   this.$emit('updateOrder')
    // },
    async getBoxData(row) {
      this.$emit("getBoxData", row);
    },
    // 编辑订单
    editOrderHandler(id) {
      this.$emit("editOrder", id);
    },
    getSummaries(param) {
      const { columns, data } = param;
      const count = (val, fixed) => {
        let c = "";
        if (!val.every(value => isNaN(value))) {
          c = val
            .reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
            .toFixed(fixed);
        } else {
          c = "";
        }
        return c;
      };
      const sums = [];
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]));
        if (
          this.statusActive === 1 ||
          this.statusActive === 2 ||
          this.statusActive === 3 ||
          this.statusActive === 4
        ) {
          if (index === 0) {
            sums[index] = "合计";
          } else if (index === 14 || index === 11) {
            sums[index] = count(values, 2);
          } else if (index === 12 || index === 13) {
            sums[index] = count(values, 0);
          }
        }
        if (this.statusActive === 5) {
          if (index === 0) {
            sums[index] = "合计";
          } else if (index === 13 || index === 10) {
            sums[index] = count(values, 2);
          } else if (index === 11 || index === 12) {
            sums[index] = count(values, 0);
          }
        }
      });
      return sums;
    },
    getTransportDetail(row) {
      this.$emit("getTransportDetail", row);
    },
    // 查看同步状态
    getDetailAsyncStatus(row) {
      this.$emit("getDetailAsyncStatus", row);
    }
  },
  created() {
    this.canInputTs = true;
    this.isFactory = true;
    // 同步状态是否显示
    let syncStatusFlag = localStorage.getItem("syncStatus");
    if (syncStatusFlag !== "0") {
      this.syncStatusFlag = true;
    } else {
      this.syncStatusFlag = false;
    }
    this.$forceUpdate();
  }
};
</script>
<style lang="scss">
.order-table {
  .el-input .el-input__inner {
    height: 18px !important;
  }

  .el-input__inner {
    padding: 0;
    text-align: center;
  }

  .detailTable {
    // line-height: 0;
    cursor: pointer;
    text-decoration: underline;
    color: #236bdc;
  }

  .cell div {
    width: 100%;
    height: 25px;
  }

  .el-input {
    width: 60px !important;
  }

  .detailTable:hover {
    color: #ff6224;
  }

  .rejectOrder {
    color: rgb(225, 145, 121);
  }

  .rejectOrder.is-disabled {
    color: #c0c4cc;
  }
}

.ts /deep/ .el-table__header-wrapper {
  /* overflow: hidden; */
  overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/bigorder/order-table.vue